/**
 * 與後端 api/src/constants/defaultAutoSendNotificationTemplates.js 文案同步，
 * 供管理後台預覽「未選範本時」的預設純文字內容。
 */

export const DEFAULT_AUTO_SEND_LINE_BODY =
  '{{memberName}} 您好，專屬好禮已發放到您的帳戶，請至官方 LINE 選單或會員相關功能查看詳情。';

export const DEFAULT_AUTO_SEND_SMS_BODY =
  '{{memberName}} 您好，專屬好禮已發放，請至官方管道查看。';

export const DEFAULT_AUTO_SEND_EMAIL_SUBJECT = '【通知】專屬好禮已發放';

export const DEFAULT_AUTO_SEND_EMAIL_BODY = `{{memberName}} 您好，

我們已為您發放專屬好禮（點數／優惠券等將依活動設定而定）。

請登入會員或查看官方訊息以了解詳情。

祝您使用愉快！`;
